import { AccordionDetails } from '@mui/material';
import { FC } from 'react';
import { Props } from '@types';

export const WalletAccordionDetails: FC<Props> = ({ children }) => {
  return (
    <AccordionDetails
      sx={{
        marginTop: '24px',
      }}
    >
      {children}
    </AccordionDetails>
  );
};
